import apiAthlete from '@/api/athlete'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  athleteIsBlockedStart: '[athlete is blocked] athlete is blocked start',
  athleteIsBlockedSuccess: '[athlete is blocked] athlete is blocked  success',
  athleteIsBlockedFailure: '[athlete is blocked] athlete is blocked  failure',
}

export const actionTypes = {
  athleteIsBlocked: '[athlete is blocked] athlete is blocked',
}

const mutations = {
  [mutationTypes.athleteIsBlockedStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.athleteIsBlockedSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.athleteIsBlockedFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.athleteIsBlocked](context, data) {
    context.commit(mutationTypes.athleteIsBlockedStart)
    return new Promise((resolve) => {
      apiAthlete
        .athleteIsBlocked(data)
        .then((response) => {
          context.commit(mutationTypes.athleteIsBlockedSuccess)
          resolve(response)
        })
        .catch((resolve) => {
          context.commit(mutationTypes.athleteIsBlockedFailure, resolve)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
